export default __webpack_public_path__ + "static/media/mafiroLogo.13477a30.png";